export const CampaignFinancialSourceEnum = {
    Company: { id: 1, name: 'Company' },
    AgentContribution: { id: 2, name: 'AgentContribution' },
};
